import React, {Component} from 'react';

import {ClientPortalTabContent} from "./ClientPortalTabContent";
import {withRouterParams} from "../../utils/withRouterParams";

class ClientPortalTabPageClass extends Component {
    render() {
        return (
            <ClientPortalTabContent clientId={this.props.match.params.id}/>
        )
    }
}

export const ClientPortalTabPage = withRouterParams(ClientPortalTabPageClass);
export default ClientPortalTabPage;
